import React, { useEffect, useState } from 'react';
import { Calendar } from 'lucide-react';
import { db } from '../database/supabase';

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data, error: err } = await db.getAnnouncements(true);
        if (err) throw err;
        setAnnouncements(data || []);
      } catch (err) {
        setError(err.message || 'Failed to load announcements');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const priorityBadge = (priority) =>
    priority === 'high' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800';

  const priorityLabel = (priority) => (priority === 'high' ? 'Important' : 'News');

  return (
    <div className="min-h-screen">
      <section className="bg-blue-800 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl font-bold mb-4">Announcements</h1>
          <p className="text-blue-100 max-w-2xl mx-auto">
            Stay updated with the latest news and important information from our guidance center.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          {loading && (
            <div className="flex justify-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-800" />
            </div>
          )}

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-red-700">
              {error}
            </div>
          )}

          {!loading && !error && announcements.length === 0 && (
            <p className="text-center text-gray-500 py-16">No announcements published yet.</p>
          )}

          {!loading && !error && announcements.length > 0 && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {announcements.map((announcement) => (
                <div key={announcement.id} className="card">
                  <div className="flex items-center justify-between mb-3">
                    <span className={`status-badge ${priorityBadge(announcement.priority)}`}>
                      {priorityLabel(announcement.priority)}
                    </span>
                    <span className="text-sm text-gray-500 flex items-center">
                      <Calendar className="w-4 h-4 mr-1" />
                      {new Date(
                        announcement.published_at || announcement.created_at
                      ).toLocaleDateString()}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold mb-3 text-gray-800">
                    {announcement.title}
                  </h3>
                  <p className="text-gray-600 whitespace-pre-wrap">{announcement.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsPage;
